/**
 * filter used for sorting mobile FBS extras alphabetically
 */
angular.module('bookingApp').filter('extrasSort',extrasSort);
function extrasSort(){
    function extrasAlphaSort(input){
        input.sort(function(a, b){
            return a.displayOrder - b.displayOrder;
        });
        var out = [];
        angular.forEach(input, function(input){
            out.push(input);
        });
        return out;
    }
    return extrasAlphaSort;
}